import { QueryClient } from '@tanstack/react-query';

// Custom retry function that doesn't retry on auth errors
const shouldRetry = (failureCount: number, error: unknown): boolean => {
  // Don't retry on auth errors or rate limiting
  if (error instanceof Error) {
    const message = error.message;
    if (
      message === 'SESSION_EXPIRED' ||
      message === 'RATE_LIMITED' ||
      message.includes('401') ||
      message.includes('429')
    ) {
      return false;
    }
  }
  
  // Check for axios error with specific status codes
  const axiosError = error as { response?: { status?: number } };
  if (axiosError?.response?.status === 401 || axiosError?.response?.status === 429) {
    return false;
  }
  
  // Otherwise retry up to 1 time
  return failureCount < 1;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetry,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Don't refetch on reconnect if there was an auth error
      refetchOnReconnect: false,
    },
    mutations: {
      retry: false, // Don't retry mutations
    },
  },
});